<div class="measurements-analysis" data-test="measurements-analysis">
  <mat-table
    multiTemplateDataRows
    class="table-desktop"
    *ngIf="dataSource?.data?.length > 0 && (analysis$ | async) as analysis"
    [dataSource]="dataSource"
    [trackBy]="trackById"
  >
    <ng-container matColumnDef="label">
      <mat-cell *matCellDef="let row" class="flex__child--2" data-test="table-desktop__col-label">
        {{ row.label }}
      </mat-cell>
      <mat-footer-cell
        *matFooterCellDef
        class="table-desktop__footer table-desktop__footer-description flex__child--2"
        data-test="table-desktop__col-label-footer"
      >
        <span>
          {{ 'measurements.wizard.analysis.total' | translate }}
        </span>
      </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="grams">
      <mat-cell
        *matCellDef="let row; let rowIndex = dataIndex"
        class="flex__child--2"
        data-test="table-desktop__col-grams"
      >
        <mat-form-field
          (click)="$event.stopPropagation()"
          class="full-width-field mat-form-field__no-spacing measurements-analysis__grams"
          subscriptSizing="dynamic"
          appearance="fill"
          [style.--mdc-filled-text-field-container-color]="'transparent'"
        >
          <input
            data-test="measurements-analysis__grams"
            matInput
            [step]="1"
            agrNumber
            (keyup)="updateAnalysisGrams()"
            (change)="updateAnalysisGrams()"
            [formControl]="formArray.controls[rowIndex]"
          />
          <span matIconSuffix>
            {{ 'measurements.wizard.grams' | translate }}
          </span>
        </mat-form-field>
      </mat-cell>
      <mat-footer-cell
        *matFooterCellDef
        class="table-desktop__footer table-desktop__footer-description flex__child--2"
        data-test="table-desktop__col-grams-footer"
      >
        <span *ngIf="analysis.total >= 0; else noTotal">
          {{ analysis.total | agrNumber: '1.0-1' }}
        </span>
        <ng-template #noTotal>
          <span>-</span>
        </ng-template>
        <span>&nbsp;{{ 'measurements.wizard.grams' | translate }}</span>
      </mat-footer-cell>
    </ng-container>

    <mat-row *matRowDef="let row; columns: ['label', 'grams']"></mat-row>
    <mat-footer-row *matFooterRowDef="['label', 'grams']"></mat-footer-row>
  </mat-table>

  <div
    *ngIf="totalGramsInputIsMoreThenZero() === false"
    class="notification notification-warning text--input-small spacing--margin-none-bottom"
  >
    <mat-icon class="flex--align-self-center">warning</mat-icon>
    {{ 'measurements.wizard.analysis.only-zero-values-error' | translate }}
  </div>
</div>
